import { getAccessToken } from 'projects/lib-shared-common/src/public-api';

// djb2: a short, stable fingerprint, not a security hash.
export const hashText = (text: string): number => text.split('').reduce((hash, char) => ((hash << 5) + hash + char.charCodeAt(0)) | 0, 5381);

export const getAccessTokenSessionKey = (): string | null => {
  const token = getAccessToken();
  return token ? hashText(token).toString(36) : null;
};
